import { getLogs } from "api/logbook/calls";
import { createPrimitivePaginatedHook } from "hooks/createPrimitiveHook";

export const useLogs = createPrimitivePaginatedHook(getLogs);
